import { SettingsSection } from '@components'

import { Divider, Flex, FormItemsGroup, Icon, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Bank } from './elements/Bank'
import { Iban } from './elements/Iban'
import { OfflinePayment } from './elements/OfflinePayment'
import { PaypalEmail } from './elements/PaypalEmail'
import { Swift } from './elements/Swift'

export const PaymentSettings = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.payment_methods.title')}>
      <Flex alignItems="center" gap={Spacing.S8}>
        <Icon icon="bank" />
        <Text weight="bold">{t('settings.organization.external_invoice.payment_methods.bank_transfer.title')}</Text>
      </Flex>
      <Space size="s24" />
      <FormItemsGroup>
        <Iban />
        <FormItemsGroup columnSpacing={Spacing.S16} itemsInRow={2}>
          <Swift />
          <Bank />
        </FormItemsGroup>
      </FormItemsGroup>
      <Space size="s24" />
      <Divider />
      <Space size="s24" />
      <Flex alignItems="center" gap={Spacing.S8}>
        <Icon icon="paypal" />
        <Text weight="bold">{t('settings.organization.external_invoice.payment_methods.paypal.title')}</Text>
      </Flex>
      <Space size="s24" />
      <PaypalEmail />
      <Space size="s24" />
      <Divider />
      <Space size="s24" />
      <Flex alignItems="center" gap={Spacing.S8}>
        <Icon icon="banknote" />
        <Text weight="bold">{t('settings.organization.external_invoice.payment_methods.offline_payment.title')}</Text>
      </Flex>
      <Space size="s24" />
      <Space />
      <OfflinePayment />
    </SettingsSection.Content>
  )
}
